import { Component, ElementRef, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-part-category',
  template: `
  <ng-template #modalPartCategory let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Agregar categoría</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-4">
      <form [formGroup]="formPartsCategory" (ngSubmit)="savePartCategory()">
        <div class="form-group mt-4">
          <label for="name" class="form-control-label">Nombre</label>
          <input type="text" class="form-control" formControlName="name" placeholder="">
          <div *ngIf="ff['name'].touched && ff['name'].invalid">
            <div *ngIf="ff['name'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="description" class="form-control-label">Descripción</label>
          <input type="text" class="form-control" formControlName="description" placeholder="">
          <div *ngIf="ff['description'].touched && ff['description'].invalid">
            <div *ngIf="ff['description'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="structural" class="form-control-label">Estructural</label>
          <input type="text" class="form-control" formControlName="structural" placeholder="">
          <div *ngIf="ff['structural'].touched && ff['structural'].invalid">
            <div *ngIf="ff['structural'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
          </div>
        </div>        
        <div class="form-group mt-4 text-end">
          <button type="submit" class="btn btn-zazz-dark">Guardar</button>
        </div>
      </form>
    </div>
  </ng-template>
  `,
  styles: [
  ]
})
export class ModalPartCategoryComponent {
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalPartCategory') modalPartCategory !: ElementRef;

  private modalRef: NgbModalRef | undefined;
  formPartsCategory: FormGroup = new FormGroup({});

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder
  ) {
    this.initForm();
  }

  initForm() {
    this.formPartsCategory = this.fb.group({
      name: [''],
      description: [''],
      parent: [''],
      is_active: [true]
    });
  }

  get ff() {
    return this.formPartsCategory.controls
  }

  savePartCategory() {}

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
